import { AppSettings } from '../app.settings';
import { ThirdPartyScreenFiltersDataModel } from './third-party-screen-filters-data-model';

export class ThirdPartyScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
  filterData: ThirdPartyScreenFiltersDataModel = new ThirdPartyScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    filterData: ThirdPartyScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.filterData = options.filterData;
    }
  }
};
